import request from '@/shared/api/request';

export const saveStackletTags = (id: number, tags: string[]): Promise<{ tags: string[] }> =>
  request({
    url: `/stacklets/${id}/tags/`,
    method: 'PUT',
    data: { tags },
  });
